exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flex-container {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: space-around;\n      align-items: space-around;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -ms-flex-flow: row wrap;\n      flex-flow: row wrap;\n  -ms-flex-line-pack: stretch;\n      align-content: stretch;\n  width: 100%;\n  height: 100%;\n}\n", ""]);

// exports
